var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-wrapper" }, [
    _c("table", { staticClass: "data-table text-sm w-full font-outfit" }, [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.headers, function (header) {
            return header.value !== "company"
              ? _c(
                  "th",
                  {
                    key: header.text,
                    staticClass:
                      "bg-lightBlue px-2 py-2 border-b-1 border-gray-200 text-left font-medium",
                    class: {
                      "resources-column": header.text === "Resources",
                    },
                  },
                  [_vm._v(" " + _vm._s(header.text) + " ")]
                )
              : _vm._e()
          }),
          0
        ),
      ]),
      _c(
        "tbody",
        [
          _vm._l(_vm.data, function (item, index) {
            return _c("tr", { key: index, staticClass: "message-unread" }, [
              _c(
                "td",
                {
                  staticClass:
                    "px-2 py-2 border-b-1 border-gray-200 flex flex-row",
                },
                [
                  _c(
                    "RouterLink",
                    {
                      attrs: {
                        to: `/company_database/contractors/${item?.id}/about`,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-storm-gray text-sm p-1 font-medium rounded-full block border border-gray-300 bg-white borderCard",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex flex-row items-center",
                              attrs: {
                                name: "imageAvatar",
                                image: item?.user?.avatar,
                              },
                            },
                            [
                              item?.user?.avatar !== null
                                ? _c("S3Image", {
                                    class: [_vm.defaultImageClasses],
                                    attrs: { s3FileKey: item?.user?.avatar },
                                  })
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-xs font-medium text-white justify-center flex items-center bg-primary-500 rounded-full bg-white w-5 h-5 mr-2",
                                  style: _vm.bgStyle(item),
                                },
                                [_vm._v(" " + _vm._s(_vm.initial(item)) + " ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-storm-gray text-sm font-medium",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.user.given_name) +
                                      " " +
                                      _vm._s(item.user.family_name) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "td",
                { staticClass: "px-2 py-2 border-b-1 border-gray-200" },
                [_vm._v(" " + _vm._s(item?.user?.private_data?.email) + " ")]
              ),
            ])
          }),
          _vm.data.length === 0 ? _c("tr", [_vm._m(0)]) : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", { staticClass: "empty-state", attrs: { colspan: "9" } }, [
      _c("div", { staticClass: "empty-state-text" }, [_vm._v("No resources")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }